export function createFilterOption ({
  chip = undefined,
  text,
  value,
  isClickable = true,
  isDisabled = false,
  onClick = null,
  group = null,
}) {
  if (typeof text !== 'string') {
    console.error('Expected text to be a String.')
  }
  if (!text || text.length < 1) {
    console.error('Expected text to not be Empty.')
  }
  if (value < -2) {
    console.error('Expected value to greater or equals -2.')
  }

  return { chip, text, value, isClickable, isDisabled, onClick, group }
}

export function createDropdownOption ({
  id,
  text,
  dataTest = undefined,
  disabled = undefined,
  group = undefined,
  iconColorClass = undefined,
  iconName = undefined,
  imageSrc = undefined,
}) {
  if (typeof text !== 'string') {
    console.error('Expected text to be a String.')
  }
  if (!text || text.length < 1) {
    console.error('Expected text to not be Empty.')
  }

  return { id, text, dataTest, disabled, group, iconColorClass, iconName, imageSrc }
}
